@if (player && tournamentRegistrations && allPlayers) {
  <mat-card appearance="outlined">
    <mat-card-content>
      @for (tournamentRegistration of getTournamentRegistrations(); track tournamentRegistration.id) {
        <mat-card appearance="outlined" class="mb-3">
          <mat-card-header>
            <h6>{{ tournamentRegistration.name }}</h6>
          </mat-card-header>
          <mat-card-content>
            @for (eventRegistration of tournamentRegistration.events; track eventRegistration.id) {
              <div class="row event-row">
                <div class="col-md-2">
                  <mat-checkbox [disabled]="!tournamentRegistration.editable" [(ngModel)]="eventRegistration.registered" (change)="updateModelWhenEventChecked(eventRegistration, $event)" name="registered">
                    {{ EventRegistration.getType(eventRegistration.type) }}
                  </mat-checkbox>
                </div>
                <div class="col-md-4">
                  @if (eventRegistration.doublesEvent) {
                    <mat-form-field appearance="fill">
                      <mat-label>Partner</mat-label>
                      <input type="text"
                             matInput
                             [matAutocomplete]="auto"
                             [disabled]="!tournamentRegistration.editable || !eventRegistration.registered"
                             [(ngModel)]="eventRegistration.partner"
                             (input)="onPartnerSearch($any($event.target).value, eventRegistration)"
                             [name]="'partner-' + eventRegistration.id">
                      <mat-autocomplete #auto="matAutocomplete"
                                        [displayWith]="displayPartnerName.bind(this)"
                                        (optionSelected)="onPartnerSelected($event, eventRegistration)">
                        <mat-option [value]="null">Geen</mat-option>
                        @for (player of getFilteredPlayers(eventRegistration); track player.id) {
                          <mat-option [value]="player.id">
                            {{ player | fullName }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                </div>
                <div class="col-6"></div>
              </div>
            }
          </mat-card-content>
          @if (tournamentRegistration.editable) {
            <mat-card-actions>
                <button mat-button (click)="saveRegistration(tournamentRegistration, $event)" [disabled]="waitingForBackend">
                  <mat-icon>save</mat-icon>
                  Opslaan
                </button>
                <a mat-button routerLink="/players">
                  <mat-icon>cancel</mat-icon>
                  Annuleren
                </a>
            </mat-card-actions>
          }
        </mat-card>
      }
      @if (!this.showAll) {
        <button mat-button (click)="this.showAll = true">
          <mat-icon>expand</mat-icon>
          Toon inactieve toernooien
        </button>
      }
    </mat-card-content>
  </mat-card>
}
